export const MACROS_NAMES = {
    PREVIEW_CONF_DESKTOP: 'PREVIEW_CONF_DESKTOP',
    PREVIEW_CONF_MOBILE: 'PREVIEW_CONF_MOBILE',
    LITE_UNIT_VERSION: 'LITE_UNIT_VERSION',
};

export const MACROS_IDS = {
    PREVIEW_CONF_DESKTOP: 335345,
    PREVIEW_CONF_MOBILE: 335355,
    LITE_UNIT_VERSION: 334115,
    UNIT_VERSION_DIRECT: 334685,
    PLAYER_VERSION: 3215,
};

export const VERSION_MACROS = {
    UNIT_VERSION_DIRECT: '~!unit_version_direct!~',
    PLAYER_VERSION: '~!player_version!~',
    LITE_UNIT_VERSION: '~!lite_unit_version!~',
};
